import { Grid, Tab, Tabs } from "@material-ui/core";
import * as React from "react";
import { GetServiceableStatus } from "../../../../../Enums/ServiceableStatus";
import { GetUnserviceableStatus } from "../../../../../Enums/UnserviceableStatus";
import { ExcelExport } from "../../../../../Helper/ExportExcel";
import { SourceEightWings } from "../../Constant/Source";
import { useStyles } from "../../RequestOrderList/styles";
import DataGrid from "./DataGrid";
import { ExcelHeader } from "./Excel";
import "./style.css";
import PoolList from "../../../../../Components/PoolListComponent/PoolListComponent";

var tabs = [
  { Value: 0, Description: "IN PROGRESS" },
  { Value: 1, Description: "ACCOMPLISHED" },
];
export const DirectDeliveryToFz = props => {
  const [activeTab, setActiveTab] = React.useState(1);
  const classes = useStyles();
  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  const ListChild = props => <DataGrid {...props} setActiveTab={setActiveTab} activeTab={activeTab} />;

  const ExportToExcel = (records, fetchRelatedRecords) => {
    fetchRelatedRecords(records, "status", "pbhrequeststatusinfo/reference").then(statusResult => {
      const data = records.map(record => ({
        ...record,
        status: `${statusResult?.[record.status]?.displayName}`,
      }));

      ExcelExport(
        ExcelHeader,
        data.map(value => [
          value.request.refNo,
          value.serviceable.awb,
          value.request.requirementCategoryText,
          value.request.pn,
          value.request.pnDescription,
          value.serviceable?.pn,
          value.serviceable?.sn,
          value.request.airportCode,
          value.request.customerPo,
          value.request.createdDate,
          value.request.requestedDeliveryDate === null
            ? "Not Arrived Yet"
            : value.request.requestedDeliveryDate == new Date("01/01/9999")
              ? "Exclude"
              : value.request.requestedDeliveryDate,
          value.status,
          GetServiceableStatus?.find?.(x => x.Value == value?.serviceable?.status)?.Description ?? "",
          GetUnserviceableStatus?.find?.(x => x.Value == value?.unserviceable?.status)?.Description ?? "",
        ]),
        "Direct Delivery to FZ"
      );
    });
  };
  return (
    <div style={{ maxWidth: window.innerWidth - window.innerWidth * 0.13, overflow: "auto" }}>
      <Tabs
        style={{ width: "100%" }}
        variant={"fullWidth"}
        centered
        value={activeTab}
        indicatorColor="primary"
        onChange={handleChange}
      >
        {tabs.map((tab: any) => {
          return <Tab key={tab.Value + "tab"} label={tab.Description} value={tab.Value} />;
        })}
      </Tabs>
      <div style={{ maxWidth: window.innerWidth - window.innerWidth * 0.15, overflow: "auto" }}>
        <Grid container spacing={0}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <PoolList
              {...props}
              id="pbh-request-list"
              emptyWhileLoading={true}
              resource={`${SourceEightWings}/getdirectdeliverylist`}
              basePath={SourceEightWings}
              className={classes.list}
              title={"Direct Delivery to FZ"}
              filterDefaultValues={{ tabValue__eq: 1 }}
              sort={{ field: "id", order: "DESC" }}
              exporter={ExportToExcel}
            >
              <ListChild />
            </PoolList>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};
export default DirectDeliveryToFz;
